import React from "react";
import { Container, Badge } from "react-bootstrap";
import { Helmet } from "react-helmet";
import AppNavbar from "../../../components/common/AppNavbar";

const NobelPeacePrize2026NaviPillay = () => {
  return (
    <>
      {/* ══════════════════════════════════════════════
          SEO — HELMET
      ══════════════════════════════════════════════ */}
      <Helmet>
        {/* ── Core Meta ── */}
        <html lang="en" />
        <title>
          Nobel Peace Prize 2026: Navi Pillay, South African Jurist of Indian
          Tamil Descent, Wins – Bharat Abroad
        </title>
        <meta
          name="description"
          content="South African jurist and former UN human rights chief Navanethem Navi Pillay wins the 2026 Nobel Peace Prize for her efforts to promote peace and international law. Who she is, why she won, her Indian Tamil roots, and what it means for the Indian diaspora."
        />
        <meta
          name="keywords"
          content="Nobel Peace Prize 2026, Navi Pillay, Navanethem Pillay, Nobel Peace Prize winner 2026, South African jurist, UN High Commissioner for Human Rights, Indian origin Nobel winner, Tamil origin South African, international law, Norwegian Nobel Committee, Jorgen Watne Frydnes, Bharat Abroad"
        />
        <meta name="author" content="Bharat Abroad Editorial" />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta name="theme-color" content="#0b1730" />
        <link
          rel="canonical"
          href="https://www.bharatabroad.com/articles/nobel-peace-prize-2026-navi-pillay"
        />

        {/* ── Geo / Audience ── */}
        <meta name="geo.region" content="IN" />
        <meta name="geo.placename" content="India" />
        <meta
          name="audience"
          content="Indians abroad, Indian diaspora, NRI community, people of Indian origin"
        />

        {/* ── Open Graph ── */}
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Nobel Peace Prize 2026: Navi Pillay, South African Jurist of Indian Tamil Descent, Wins – Bharat Abroad"
        />
        <meta
          property="og:description"
          content="Navi Pillay, former UN High Commissioner for Human Rights, wins the 2026 Nobel Peace Prize for promoting peace and international law. Full explainer for the Indian diaspora."
        />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/articles/nobel-peace-prize-2026-navi-pillay"
        />
        <meta property="og:site_name" content="Bharat Abroad" />
        <meta property="og:locale" content="en_IN" />
        {/* TODO: replace with your own licensed image */}
        <meta
          property="og:image"
          content="https://www.bharatabroad.com/images/nobel-peace-prize-2026.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Nobel Peace Prize 2026 — Navi Pillay, South African jurist and former UN human rights chief"
        />
        <meta
          property="article:published_time"
          content="2026-10-09T15:45:00+05:30"
        />
        <meta
          property="article:modified_time"
          content="2026-10-09T15:45:00+05:30"
        />
        <meta
          property="article:author"
          content="https://www.bharatabroad.com/about"
        />
        <meta
          property="article:publisher"
          content="https://www.bharatabroad.com"
        />
        <meta property="article:section" content="World" />
        <meta property="article:tag" content="Nobel Peace Prize" />
        <meta property="article:tag" content="Navi Pillay" />
        <meta property="article:tag" content="International Law" />
        <meta property="article:tag" content="Human Rights" />
        <meta property="article:tag" content="South Africa" />
        <meta property="article:tag" content="Indian Diaspora" />

        {/* ── Twitter Card ── */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@BharatAbroad" />
        <meta name="twitter:creator" content="@BharatAbroad" />
        <meta
          name="twitter:title"
          content="Nobel Peace Prize 2026: Navi Pillay Wins – Bharat Abroad"
        />
        <meta
          name="twitter:description"
          content="South African jurist of Indian Tamil descent Navi Pillay wins the 2026 Nobel Peace Prize for promoting peace and international law."
        />
        <meta
          name="twitter:image"
          content="https://www.bharatabroad.com/images/nobel-peace-prize-2026.jpg"
        />
        <meta
          name="twitter:image:alt"
          content="Nobel Peace Prize 2026 — Bharat Abroad"
        />

        {/* ── JSON-LD: NewsArticle ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": "Nobel Peace Prize 2026: Navi Pillay, South African Jurist of Indian Tamil Descent, Wins for Promoting Peace and International Law",
            "description": "The Norwegian Nobel Committee has awarded the 2026 Nobel Peace Prize to South African jurist and former UN High Commissioner for Human Rights Navanethem Navi Pillay, for her efforts to promote peace and international law.",
            "image": {
              "@type": "ImageObject",
              "url": "https://www.bharatabroad.com/images/nobel-peace-prize-2026.jpg",
              "width": 1200,
              "height": 630
            },
            "datePublished": "2026-10-09T15:45:00+05:30",
            "dateModified": "2026-10-09T15:45:00+05:30",
            "author": {
              "@type": "Organization",
              "name": "Bharat Abroad Editorial",
              "url": "https://www.bharatabroad.com/about"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Bharat Abroad",
              "url": "https://www.bharatabroad.com"
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.bharatabroad.com/articles/nobel-peace-prize-2026-navi-pillay"
            },
            "articleSection": "World",
            "keywords": "Nobel Peace Prize 2026, Navi Pillay, international law, human rights, South Africa, Indian diaspora",
            "wordCount": "1200",
            "timeRequired": "PT7M",
            "inLanguage": "en-IN",
            "about": [
              { "@type": "Thing", "name": "Nobel Peace Prize" },
              { "@type": "Person", "name": "Navanethem Pillay" },
              { "@type": "Thing", "name": "International Law" },
              { "@type": "Thing", "name": "Human Rights" }
            ],
            "audience": {
              "@type": "Audience",
              "audienceType": "Indian diaspora and people of Indian origin worldwide"
            }
          }
        `}</script>

        {/* ── JSON-LD: BreadcrumbList ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",  "item": "https://www.bharatabroad.com" },
              { "@type": "ListItem", "position": 2, "name": "World", "item": "https://www.bharatabroad.com/world" },
              { "@type": "ListItem", "position": 3, "name": "Nobel Peace Prize 2026", "item": "https://www.bharatabroad.com/articles/nobel-peace-prize-2026-navi-pillay" }
            ]
          }
        `}</script>

        {/* ── JSON-LD: FAQPage ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Who won the Nobel Peace Prize in 2026?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "South African jurist Navanethem Navi Pillay, a former UN High Commissioner for Human Rights, won the 2026 Nobel Peace Prize. The Norwegian Nobel Committee announced the award in Oslo on 9 October 2026."
                }
              },
              {
                "@type": "Question",
                "name": "Why did Navi Pillay win the Nobel Peace Prize?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The committee honoured her for her efforts to promote peace and international law, highlighting her work in landmark international court cases and her role in strengthening the institutions of international law."
                }
              },
              {
                "@type": "Question",
                "name": "Is Navi Pillay of Indian origin?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes. Pillay was born in Durban, South Africa, into a family of Indian Tamil descent. She is a South African citizen."
                }
              },
              {
                "@type": "Question",
                "name": "How much is the 2026 Nobel Peace Prize worth?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The prize carries a monetary award of 9.0 million Swedish kronor. The formal ceremony takes place in Oslo on 10 December 2026."
                }
              },
              {
                "@type": "Question",
                "name": "What does this mean for the Indian diaspora?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Pillay's story, from a Durban family of Indian descent to the head of the UN human rights office and now a Nobel laureate, is being widely celebrated across the Indian diaspora, particularly among South African Indians and Tamil communities."
                }
              }
            ]
          }
        `}</script>

        {/* ── JSON-LD: WebSite ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Bharat Abroad",
            "url": "https://www.bharatabroad.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://www.bharatabroad.com/search?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          }
        `}</script>
      </Helmet>

      <AppNavbar />

      <div style={{ background: "#f4f7fb" }}>
        {/* ══════════════════════════════
            HERO SECTION
        ══════════════════════════════ */}
        <div
          style={{
            background: "linear-gradient(135deg, #0b1730, #13264d, #1c3a73)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="warning" text="dark" className="mb-3">
              🕊️ Breaking · World · October 2026
            </Badge>
            <h1 className="fw-bold">
              Nobel Peace Prize 2026: Navi Pillay, South African Jurist of
              Indian Tamil Descent, Wins for Promoting Peace and International
              Law
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              The former UN High Commissioner for Human Rights, who began her
              career as a lawyer defending anti-apartheid activists, has been
              named this year's laureate by the Norwegian Nobel Committee.
            </p>
          </Container>
        </div>

        {/* ══════════════════════════════
            BODY
        ══════════════════════════════ */}
        <section>
          <div className="container py-5">
            <p>
              The Norwegian Nobel Committee announced in Oslo on Friday, 9
              October 2026, that the Nobel Peace Prize goes to Navanethem "Navi"
              Pillay, a South African jurist and former United Nations High
              Commissioner for Human Rights. The committee's chair, Jørgen Watne
              Frydnes, said the award recognises her efforts to promote peace
              and international law.
            </p>
            <p>
              For readers of Bharat Abroad, the news carries a special
              resonance: Pillay was born in Durban into a family of Indian Tamil
              descent, making her one of the most prominent people of Indian
              origin on the global stage.
            </p>

            {/* ── Stat Cards ── */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                gap: "12px",
                margin: "24px 0",
              }}
            >
              {[
                {
                  label: "Announced",
                  value: "9 Oct 2026",
                  delta: "Oslo, Norway",
                },
                {
                  label: "Nominations",
                  value: "287",
                  delta: "Reviewed by the committee",
                },
                {
                  label: "Prize money",
                  value: "9.0M SEK",
                  delta: "Swedish kronor",
                },
                {
                  label: "Ceremony",
                  value: "10 Dec",
                  delta: "Oslo, 2026",
                },
              ].map((s) => (
                <div
                  key={s.label}
                  style={{
                    background: "#fff",
                    border: "1px solid #dde2ea",
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      textTransform: "uppercase",
                      letterSpacing: "0.06em",
                      color: "#999",
                      marginBottom: "6px",
                      fontWeight: 600,
                    }}
                  >
                    {s.label}
                  </div>
                  <div
                    style={{
                      fontSize: "22px",
                      fontWeight: 700,
                      color: "#0b1730",
                      lineHeight: 1.2,
                    }}
                  >
                    {s.value}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#0d7a5f",
                      fontWeight: 600,
                      marginTop: "3px",
                    }}
                  >
                    {s.delta}
                  </div>
                </div>
              ))}
            </div>

            <hr />

            {/* ── Section 1 ── */}
            <h3>1. Why the Committee Chose Pillay</h3>

            <h4>Law as a tool for peace</h4>
            <p>
              The committee's message centres on a simple idea: legal action can
              help prevent war and violence. Frydnes pointed to her role in
              historic international court cases as proof that accountability
              through law can have real consequences, and noted that she has
              also worked to strengthen the institutions of international law
              themselves.
            </p>

            <h4>A timely signal</h4>
            <p>
              The award arrives at a moment when many observers say
              international legal norms are under strain, from the conduct of
              wars to the standing of international courts. Honouring a jurist
              rather than a negotiator or a political leader is widely read as a
              statement about the importance of accountability in sustaining
              peace.
            </p>

            {/* Callout */}
            <div
              style={{
                borderLeft: "4px solid #0b1730",
                background: "#eef2fa",
                borderRadius: "0 8px 8px 0",
                padding: "14px 20px",
                margin: "20px 0",
                fontSize: "15px",
                color: "#333",
                lineHeight: 1.7,
              }}
            >
              <strong>
                The committee framed the prize around international law rather
                than any single conflict
              </strong>{" "}
              — recognising a career spent building and defending the courts and
              institutions that hold perpetrators of mass violence to account.
            </div>

            <hr />

            {/* ── Section 2 ── */}
            <h3>2. Who Is Navi Pillay?</h3>
            <p>
              Pillay grew up in Durban under apartheid, in a family descended
              from Indian Tamil migrants to South Africa. She went on to qualify
              as a lawyer at a time when the system closed most doors to
              non-white South Africans, and she built a practice defending
              anti-apartheid activists and political prisoners. She later became
              the first woman of colour appointed to the High Court of South
              Africa.
            </p>
            <p>
              Her international career began in the 1990s. She served as a judge
              and later president of the International Criminal Tribunal for
              Rwanda, where the tribunal's 1998 judgment in the Akayesu case
              became a landmark: it was the first conviction for genocide by an
              international court and recognised rape as an act of genocide. She
              then served as a judge of the International Criminal Court before
              being appointed UN High Commissioner for Human Rights, a post she
              held from 2008 to 2014.
            </p>

            <h4>Recent honours and recent work</h4>
            <p>
              Pillay received the 2025 Sydney Peace Prize, which the Sydney
              Peace Foundation presented in November 2025 for her lifelong
              advocacy for accountability and human rights. The Olof Palme Memorial
              Fund also announced her as a 2026 laureate, jointly with the South
              African international lawyer John Dugard.
            </p>
            <p>
              Most recently she chaired the UN Commission of Inquiry on the
              Occupied Palestinian Territory. That commission concluded that
              Israel had committed genocide in Gaza, a finding Israel has
              rejected. Her work there is likely to draw both praise and
              criticism in the coming weeks, as is often the case with
              laureates whose careers touch live conflicts.
            </p>

            <hr />

            {/* ── Section 3 — Timeline ── */}
            <h3>3. Career Milestones</h3>

            <h4>1941</h4>
            <p>Born in Durban, South Africa, into a family of Indian Tamil descent.</p>

            <h4>1960s–1990s</h4>
            <p>
              Practises law under apartheid, defending activists and political
              prisoners, and is later appointed to the High Court of South
              Africa.
            </p>

            <h4>1995–2003</h4>
            <p>
              Serves as a judge, and later president, of the International
              Criminal Tribunal for Rwanda; the 1998 Akayesu judgment sets
              global precedent on genocide and sexual violence.
            </p>

            <h4>2003–2008</h4>
            <p>Serves as a judge of the International Criminal Court in The Hague.</p>

            <h4>2008–2014</h4>
            <p>Serves as UN High Commissioner for Human Rights.</p>

            <h4>2021–2025</h4>
            <p>
              Chairs the UN Commission of Inquiry on the Occupied Palestinian
              Territory.
            </p>

            <h4>November 2025</h4>
            <p>Receives the Sydney Peace Prize in Sydney.</p>

            <h4>9 October 2026</h4>
            <p>
              Named the 2026 Nobel Peace Prize laureate by the Norwegian Nobel
              Committee; the formal ceremony is set for 10 December in Oslo.
            </p>

            <hr />

            {/* ── Section 4 ── */}
            <h3>4. Reaction and What Comes Next</h3>
            <p>
              Congratulations from human rights groups, legal scholars and
              political leaders are expected to continue through the weekend.
              Several outlets noted the announcement came despite a renewed
              public push by US President Donald Trump to win the prize. As in
              every year, the committee's choice will also be debated, with
              supporters seeing a defence of the rule of law and critics
              questioning how the prize intersects with ongoing political
              disputes.
            </p>
            <p>
              The laureate will formally receive the medal and diploma at the
              Oslo ceremony on 10 December 2026, together with the prize money of
              9.0 million Swedish kronor.
            </p>

            <hr />

            {/* ── Summary ── */}
            <h3>What This Means for the Indian Diaspora</h3>

            <p>
              Pillay's journey is a powerful story for people of Indian origin
              around the world, and a few threads stand out:
            </p>

            <ul>
              <li>
                She is the daughter of a South African Indian community whose
                ancestors arrived generations ago, and her rise from a Durban
                childhood under apartheid to the head of the UN human rights
                office is being celebrated across the diaspora
              </li>
              <li>
                Her Tamil heritage is drawing particular pride in Tamil
                communities from Tamil Nadu to Singapore, Malaysia and South
                Africa
              </li>
              <li>
                Her career shows how legal training and public service can open
                doors in international institutions, an inspiration for Indian
                students and young professionals studying or working in law and
                policy abroad
              </li>
              <li>
                The prize puts international law and accountability back in the
                global spotlight, themes that matter to migrants and minority
                communities who rely on legal protections in their host
                countries
              </li>
            </ul>

            <p>
              From a Durban law office to the Nobel stage in Oslo, Navi Pillay's
              career is a reminder of what sustained legal courage can achieve —
              and of the global reach of the Indian diaspora.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default NobelPeacePrize2026NaviPillay;
